import type GameStrapi from "~/libs/interfaces/GameStrapi";
import type GameLocal from "~/libs/interfaces/GameLocal";

const gameLocalFactory = {
  createGameFromStrapi(game?: GameStrapi): GameLocal | undefined {
    if (!game) {
      return undefined;
    }
    return {
      id: game.id,
      documentId: game.documentId,

      createdAt: game.createdAt ? new Date(game.createdAt) : undefined,
      updatedAt: game.updatedAt ? new Date(game.updatedAt) : undefined,
      publishedAt: game.publishedAt ? new Date(game.publishedAt) : undefined,

      name: game.name,
      header: game.header,
      description: game.description,
      howToPlayInfo: game.howToPlayInfo,
      isEnabled: game.isEnabled,

      drawStartTime: game.drawStartTime,
      drawCountdownTime: game.drawCountdownTime,
      drawTime: game.drawTime,
      drawCloseTime: game.drawCloseTime,

      prize: game.prize,
      prizeDescription: game.prizeDescription,

      drawMonday: game.drawMonday,
      drawTuesday: game.drawTuesday,
      drawWednesday: game.drawWednesday,
      drawThursday: game.drawThursday,
      drawFriday: game.drawFriday,
      drawSaturday: game.drawSaturday,
      drawSunday: game.drawSunday,

      ...(game.nextDrawTimes && {
        nextDrawTimes: {
          drawCloseTime: game.nextDrawTimes.drawCloseTime ? new Date(game.nextDrawTimes.drawCloseTime) : undefined,
          drawCountdownTime: game.nextDrawTimes.drawCountdownTime ? new Date(game.nextDrawTimes.drawCountdownTime) : undefined,
          drawStartTime: game.nextDrawTimes.drawStartTime ? new Date(game.nextDrawTimes.drawStartTime) : undefined,
          drawTime: game.nextDrawTimes.drawTime ? new Date(game.nextDrawTimes.drawTime) : undefined,
        }
      }),
    }
  }
}
export default gameLocalFactory